import {useClientLocator} from "../../../client/ApiClientLocator";
import {SubmissionDto, SubmissionStateDto} from "../../../client/submission/SubmissionApiClient";
import {useTranslation} from "react-i18next";
import {List} from "@mui/material";
import {useSnackbar} from "@dain/mui-components"
import SubmissionStateListItem from "../state/SubmissionStateListItem";
import {useEffect, useState} from "react";
import {CommonTranslKey} from "../../../common/CommonTranslKey";
import Skeleton from "../../../common/skeleton/Skeleton";
import UserResolver from "../../user/UserResolver";
import PersonAnonymizer from "../../person/PersonAnonymizer";

export interface SubmissionStateHistoryPanelProps {
    submission?: SubmissionDto;
    anonymizePersonNames?: boolean;
}

export default function SubmissionStateHistoryPanel(props: SubmissionStateHistoryPanelProps) {
    const {submission, anonymizePersonNames} = props;

    const {submissionClient} = useClientLocator();
    const snackbar = useSnackbar();
    const {t} = useTranslation();

    const [states, setStates] = useState<SubmissionStateDto[]>();

    useEffect(() => {
        if (submission) {
            submissionClient.findSubmissionStates(submission.id)
                .then((states) => {
                    if (anonymizePersonNames) {
                        states.forEach((state) => {
                            if (state.triggeredBy?.person && !UserResolver.isSystem(state.triggeredBy)) {
                                state.triggeredBy.person = PersonAnonymizer.anonymizePerson(state.triggeredBy.person);
                            }
                        });
                    }

                    setStates(states);
                })
                .catch((error) => snackbar.error(t(CommonTranslKey.UNEXPECTED_ERROR), error));
        }
    }, [submission, anonymizePersonNames, submissionClient, snackbar, t]);


    if (!submission || !states) {
        return (
            <Skeleton count={2}/>
        );
    }

    return (
        <List component={"nav"}>
            {
                states.map((state) =>
                    <SubmissionStateListItem key={state.id} state={state} isActive={state.id === submission.currentSubmissionState.id} />)
            }
        </List>
    );
}
